var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPaymentMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833984,
    y: 0.5,
    width: 45.6667,
    height: 31,
    rx: 5.5,
    fill: "white",
    stroke: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 22.8753C22.4112 24.2463 20.3503 25.074 18.0984 25.074C13.0735 25.074 9 20.9532 9 15.87C9 10.7868 13.0735 6.66602 18.0984 6.66602C20.3503 6.66602 22.4112 7.49368 24 8.86472C25.5888 7.49368 27.6497 6.66602 29.9016 6.66602C34.9265 6.66602 39 10.7868 39 15.87C39 20.9532 34.9265 25.074 29.9016 25.074C27.6497 25.074 25.5888 24.2463 24 22.8753Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 22.8753C25.9563 21.1871 27.1967 18.6751 27.1967 15.87C27.1967 13.0649 25.9563 10.5529 24 8.86472C25.5888 7.49368 27.6497 6.66602 29.9016 6.66602C34.9265 6.66602 39 10.7868 39 15.87C39 20.9532 34.9265 25.074 29.9016 25.074C27.6497 25.074 25.5888 24.2463 24 22.8753Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9994 22.8756C25.9556 21.1874 27.196 18.6755 27.196 15.8704C27.196 13.0654 25.9556 10.5534 23.9994 8.86523C22.0432 10.5534 20.8027 13.0654 20.8027 15.8704C20.8027 18.6755 22.0432 21.1874 23.9994 22.8756Z",
    fill: "#FF5E00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPaymentMastercard);
export default __webpack_public_path__ + "static/media/ic-payment-mastercard.fb49506fe01c50b8414e9c74cf6713ec.svg";
export { ForwardRef as ReactComponent };